<app-carousel></app-carousel>
<app-services-provide></app-services-provide>
<app-choose-us></app-choose-us>
<app-technologies></app-technologies>
<app-features-project></app-features-project>
<!-- <app-products></app-products> -->
<app-clients></app-clients>
<app-extensive-reach></app-extensive-reach>